<template>
  <div class="app-sidebar">
    <div class="text-right">
      <button type="button" class="btn btn-sidebar" @click="hide()">
        <span class="x"></span>
      </button>
    </div>
    <div class="sidebar-header">
      <img src="/img/logo.svg" class="user-photo">
      <p class="username">
        <!-- {{ userName }}<br>
        <small>{{ userEmail }}</small> -->
        {{ whoAmI.holder.fullName }}<br>
        <small>{{ whoAmI.holder.email }}</small>
      </p>
    </div>
    <ul id="sidebar-nav" class="sidebar-nav">
      <li>
        <a href="#" class="sidebar-nav-link">
          <router-link :to="{ name: 'sellers' }" class="sidebar-nav-link">
            <i class="icon-people"></i> Cadastros
          </router-link>
        </a>
      </li>
      <li>
        <a href="#" class="sidebar-nav-link">
          <router-link :to="{ name: 'occurrences' }" class="sidebar-nav-link">
            <i class="icon-magnifier"></i> Ocorrências
          </router-link>
        </a>
      </li>
      <li>
        <a href="#" class="sidebar-nav-link">
          <router-link :to="{ name: 'search-transactions' }" class="sidebar-nav-link">
            <i class="icon-magnifier"></i> Consultar transações
          </router-link>
        </a>
      </li>
    </ul>
    <div class="sidebar-footer">
      <a href="#" data-toggle="tooltip" title="Sair" @click.prevent="logout()">
        <i class="icon-logout"></i>
      </a>
      <a href="#" data-toggle="tooltip" title="Configurações">
        <i class="icon-settings"></i>
      </a>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'Sidebar',
  data () {
    return {
      whoAmI: JSON.parse(localStorage.getItem('stateAntiFraud')).whoAmI // this.$auth.whoAmI()
    }
  },
  mounted () {
    this.loadPlugins()
  },
  methods: {
    hide () {
      $('.app-sidebar').sidebar('hide')
    },
    loadPlugins () {
      $('[data-toggle="tooltip"]').tooltip()
    },
    logout () {
      $('[data-toggle="tooltip"]').tooltip('hide')

      this.$swal({
        title: 'Sair do sistema',
        text: 'Deseja realmente sair do sistema?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          localStorage.removeItem('stateAntiFraud')
          this.$router.push({ name: 'login' })
        }
      })
    }
  },
  computed: {
    userName () {
      return this.whoAmI && this.whoAmI.user && this.whoAmI.user.name
    },
    userEmail () {
      return this.whoAmI && this.whoAmI.user && this.whoAmI.user.email
    }
  },
  watch: {
    $route (from, to) {
      this.loadPlugins()
    }
  }
}
</script>
